module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src023959432/src/github.com/GipsyBot/gipsy-webapp/node_modules/axios/index.js
// module id = 50
// module chunks = 0